import useDownloadFile from "../../../../CustomHooks/useAxios/useDownloadFile";
import { VisitModalLayout } from "./VisitModalLayout";

export const VisitDialog = ({
  closeDialog,
  visit,
  openImageSlider,
  setImageSliderCurrentIndex,
  accept,
  reject,
  setVisitViewDetails,
  successView,
}) => {
  const pictureList = visit.pictureList;
  // Initialize hook to handle Visit Report PDF download
  const {
    isLoaded: isReportPdfLoaded,
    generateFile: generateReportPdf,
    ...restReportPdf
  } = useDownloadFile();

  // Initialize hook to handle Visit Photos PDF download
  const {
    isLoaded: isImagePdfLoaded,
    generateFile: generateImagePdf,
    ...restImagePdf
  } = useDownloadFile();

  return (
    <VisitModalLayout
      value={{
        closeDialog,
        visit,
        openImageSlider,
        setImageSliderCurrentIndex,
        accept,
        reject,
        setVisitViewDetails,
        successView,
        pictureList,
        isReportPdfLoaded,
        isImagePdfLoaded,
        restReportPdf,
        restImagePdf,
        generateReportPdf,
        generateImagePdf,
      }}
    >
      <VisitModalLayout.Header />
      <VisitModalLayout.ContentWrapper>
        <VisitModalLayout.VisitDetails />
        <VisitModalLayout.VisitPictures />
        <VisitModalLayout.VisitRemark />
        <VisitModalLayout.VisitSigns />
      </VisitModalLayout.ContentWrapper>
      <VisitModalLayout.VisitFooter />
      <VisitModalLayout.VisitDownloads />
    </VisitModalLayout>
  );
};
